// google-analytics.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  constructor() {
    // Initialize Google Analytics if necessary
  }

  public event(action: string, category: string, label?: string, value?: number): void {
    if (window['gtag']) {
      window['gtag']('event', action, {
        event_category: category,
        event_label: label,
        value: value
      });
    } else if (window['ga']) {
      window['ga']('send', 'event', category, action, label, value);
    }
  }
}
